module.exports = __webpack_public_path__ + "static/media/PDF_97.f8f147f7.pdf";